import moment from "moment";

import { PhoneNumber } from "@/Common/Api/Contacts/Dto/PhoneNumber";
import { IndividualLight } from "@/Common/Api/Individuals/Dto/IndividualLight";
import { PortalLinkedItemType } from "@/Common/Models/Portal/Enums/PortalLinkedItemType";
import { PortalSyncStatus } from "@/Common/Models/Portal/Enums/PortalSyncStatus";
import { ITableDataSourceItem } from "@/Common/Models/UI/Tables/ITableDataSourceItem";

class PortalSyncHistoryTableItem implements ITableDataSourceItem<SharedItemHistoryDto> {
    public Model: SharedItemHistoryDto;
    public Name: string;

    constructor(model: SharedItemHistoryDto) {
        this.Model = model;
    }
}

class SharedItemHistoryDto {
    public SharedItemId: string;
    public SharedItemMessageId?: number;
    public SharedItemType: PortalLinkedItemType;
    public Subject: string;
    public MessageText: string;
    public Patient: IndividualLight;
    public PhoneNumbers: PhoneNumber[];
    public User: IndividualLight;
    public SyncDate: moment.Moment;
    public SyncStatus: PortalSyncStatus;
    public ViewedDate?: moment.Moment;
    public CurrentStatus: PortalSyncStatus;
    public CurrentIncludeLinkedItem: boolean;
    public HasBeenModifiedSinceLastShared?: boolean;
}

export { PortalSyncHistoryTableItem, SharedItemHistoryDto };
